




















































import { Component, Prop, Vue } from "vue-property-decorator";
import InputText from "../form/inputText.vue";

@Component({
  inheritAttrs: false,
  components: { InputText },
})
export default class SearchBar extends Vue {
  @Prop({ type: String, default: "product" }) variant!: string;
  @Prop({ type: String, default: "div" }) tag!: string;
  @Prop({ type: String, default: "" }) value!: string;
  @Prop({ type: String, default: "" }) placeholder!: string;
  @Prop({ type: String, default: "search-form" }) inputId!: string;
  @Prop({ type: String, default: "s" }) inputName!: string;
  @Prop({ type: String, default: "off" }) autocomplete!: string;
  @Prop({ type: String, default: "" }) clearLabel!: string;

  get rootClass() {
    if (this.variant === "services") {
      return "servicesPage__search";
    }
    return "form-search rd-search form-product-search";
  }

  get clearLabelText() {
    return (this.clearLabel || this.$t("Clear")).toString();
  }

  emitInput(value: string) {
    this.$emit("input", value);
  }

  clearValue() {
    if (!this.value) return;
    this.emitInput("");
  }
}
